import { useTheme } from "../ThemeProvider";

export const ThumbsUp = () => {
    const { variant } = useTheme();
    if (variant == "dark") {
        return (
            <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M16.28 22.1H12.48C11.92 22.1 10.7 21.93 10.05 21.28L7.01999 18.94L7.93999 17.75L11.04 20.15C11.29 20.39 11.92 20.59 12.48 20.59H16.28C17.18 20.59 18.15 19.87 18.35 19.06L20.77 11.71C20.93 11.27 20.9 10.87 20.69 10.58C20.47 10.27 20.07 10.09 19.58 10.09H15.58C15.06 10.09 14.58 9.87001 14.25 9.49001C13.91 9.10001 13.76 8.58001 13.84 8.04001L14.34 4.83001C14.46 4.27001 14.08 3.64001 13.54 3.46001C13.05 3.28001 12.42 3.54001 12.2 3.86001L8.09999 9.96001L6.85999 9.13001L10.96 3.03001C11.59 2.09001 12.97 1.64001 14.05 2.05001C15.3 2.46001 16.1 3.84001 15.82 5.12001L15.33 8.27001C15.32 8.34001 15.32 8.44001 15.39 8.52001C15.44 8.57001 15.51 8.60001 15.59 8.60001H19.59C20.57 8.60001 21.42 9.01001 21.92 9.72001C22.41 10.41 22.51 11.32 22.19 12.2L19.8 19.48C19.43 20.93 17.89 22.1 16.28 22.1Z"
                    fill="white"
                />
                <path
                    d="M5.38 21H4.38C2.53 21 1.63 20.13 1.63 18.35V8.54999C1.63 6.76999 2.53 5.89999 4.38 5.89999H5.38C7.23 5.89999 8.13 6.76999 8.13 8.54999V18.35C8.13 20.13 7.23 21 5.38 21ZM4.38 7.39999C3.29 7.39999 3.13001 7.65999 3.13001 8.54999V18.35C3.13001 19.24 3.29 19.5 4.38 19.5H5.38C6.47001 19.5 6.63 19.24 6.63 18.35V8.54999C6.63 7.65999 6.47001 7.39999 5.38 7.39999H4.38Z"
                    fill="white"
                />
            </svg>
        );
    } else {
        return (
            <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M13.5667 18.4167H10.4C9.93334 18.4167 8.91668 18.275 8.37501 17.7333L5.85001 15.7833L6.61667 14.7917L9.20001 16.7917C9.40834 16.9917 9.93334 17.1583 10.4 17.1583H13.5667C14.3167 17.1583 15.125 16.5583 15.2917 15.8833L17.3083 9.75834C17.4417 9.39167 17.4167 9.05834 17.2417 8.81667C17.0583 8.55834 16.725 8.40834 16.3167 8.40834H12.9833C12.55 8.40834 12.15 8.225 11.875 7.90834C11.5917 7.58334 11.4667 7.15 11.5333 6.7L11.95 4.025C12.05 3.55834 11.7333 3.03334 11.2833 2.88334C10.875 2.73334 10.35 2.95 10.1667 3.21667L6.75001 8.3L5.71667 7.60834L9.13334 2.525C9.65834 1.74167 10.8083 1.36667 11.7083 1.70834C12.75 2.05 13.4167 3.2 13.1833 4.26667L12.775 6.89167C12.7667 6.95 12.7667 7.03334 12.825 7.1C12.8667 7.14167 12.925 7.16667 12.9917 7.16667H16.325C17.1417 7.16667 17.85 7.50834 18.2667 8.1C18.675 8.675 18.7583 9.43334 18.4917 10.1667L16.5 16.2333C16.1917 17.4417 14.9083 18.4167 13.5667 18.4167Z"
                    fill="#022213"
                />
                <path
                    d="M4.48328 17.5H3.64994C2.10828 17.5 1.35828 16.775 1.35828 15.2917V7.125C1.35828 5.64166 2.10828 4.91666 3.64994 4.91666H4.48328C6.02494 4.91666 6.77494 5.64166 6.77494 7.125V15.2917C6.77494 16.775 6.02494 17.5 4.48328 17.5ZM3.64994 6.16666C2.74161 6.16666 2.60828 6.38333 2.60828 7.125V15.2917C2.60828 16.0333 2.74161 16.25 3.64994 16.25H4.48328C5.39161 16.25 5.52494 16.0333 5.52494 15.2917V7.125C5.52494 6.38333 5.39161 6.16666 4.48328 6.16666H3.64994Z"
                    fill="#022213"
                />
            </svg>
        );
    }
};
